'use client'

import { styled } from 'styled-components'

export const StyledHotelSlide = styled.div<{ $url: string, $top: boolean; $orientation: string }>`
    background: ${props => `url(${props.$url}) no-repeat center`};
    background-repeat: no-repeat;
    background-size: contain;
    height: 100dvh;
    aspect-ratio: ${props => props.$orientation == "horizontal" ? "16/9" : "9/16"};
    
    margin-inline: auto;
    padding-inline: 1rem;
    box-sizing: border-box;
    padding-top: 0.5rem;
    padding-bottom: 1rem;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: ${props => props.$top ? "flex-start" : "flex-end"};
    ${({ $orientation }) => $orientation == "horizontal" ? `
        justify-content: flex-start;
    `: ''}

    >div:first-of-type {
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 4px;
        width: inherit;
        ${({ $orientation, $top }) => $orientation == "horizontal" ? `
            width: 40%;
            margin-top: 1rem;
            margin-left: ${$top ? "0.8rem" : "auto"};
            padding-bottom: 5rem;
            padding-inline: 0.4rem;
            overflow: ${$top ? "auto" : "hidden"};
            background-color: rgba(255, 255, 255, 0.8);
        `: ''}
    }

    >div:first-of-type {
        ${({ $orientation, $top }) => $orientation == "horizontal" ? `
            margin-left: ${$top ? "0.8rem" : "auto"};
        `: ''}
    }
`

export const StyledHotelImage = styled.div`
    width: calc(100% - 0.5rem);
    aspect-ratio: 16 / 9;
    margin-inline: auto;  
    border-radius: 4px;
`

export const StyledHotelDetails = styled.div`
    padding-block: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    text-shadow: #e4f0f3 1px 1px;
    color: #173b52;

    >div {
        display: flex;
        gap: 0.2rem;
        padding-bottom: 0.5rem;
    }

    h3 {
        font-size: 1.8rem;
        padding-bottom: 0.8rem;
    }
`

export const StyledHotelPrice = styled.div<{ $orientation: string; $top: boolean }>`
    width: 100%;
    color: white;
    font-weight: bold;
    display: flex;
    justify-content: center;
    margin-top: -0.8rem;

    span {
        font-size: 2rem;
        padding: 1rem;
        background-color: #e40227;
        border-radius: 8px;
    }

    ${({ $orientation, $top }) => $orientation == "horizontal" ? `
        width: calc(40% + 0.8rem);
        margin-top: -5.5rem;
        margin-left: ${$top ? "0.8rem" : "calc(60% - 0.8rem)"};
    `: ''}
`

export const StyledStar = styled.div`
    position: relative;
    aspect-ratio: 1 / 1;
    width: 1.4rem;
`

export const TitleH2 = styled.h2<{ $orientation: string }>`
    color: #143a52;
    text-shadow: #c7dce6 1px 1px;
    padding-left: 0.8rem;
    font-size: 1.8rem;
    padding-top: 0.3rem;

    ${({ $orientation }) => $orientation == "horizontal" ? `
        font-size: 1.6rem;
        padding-top: 0.8rem;
        padding-left: 1.1rem;
        text-shadow: #c7dce6 2px 2px;
    `: ''}
`

export const TitleH3 = styled.h3<{ $color: string; $shade?: string; $orientation: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    background-color: #db0225;
    display: inline-block;
    margin-left: -1rem;
    margin-bottom: -1rem;
    padding-inline: 2rem 1rem;
    padding-block: 0.3rem;
    position: relative;
    font-size: 3rem;

    ${({ $orientation, $shade }) => $orientation == "horizontal" ? `
        margin-left: -2.2rem;
        padding-left: 3.2rem;
        ${$shade ? `text-shadow: ${$shade} 2px 2px;` : ""}
    `: ''}

    &:after {
        content: "";
        position: absolute;
        background-color: white;
        left: 2rem;
        width: calc(100% - 2rem);
        ${({ $orientation }) => $orientation == "horizontal" ? `
            left: 3.4rem;
            width: calc(100% - 3.4rem);
        `: ''}

        bottom: -4px;
        height: 4px;
    }
`

export const StyledHotelRow = styled.span<{ $color: string; $shade?: string; $orientation: string }>`
    font-size: 1.4rem;
    display: block;
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    ${({ $orientation, $shade }) => $orientation == "horizontal" ? `
        ${$shade ? `text-shadow: ${$shade} 2px 2px;` : ""}
    `: ''}
`
